import { useDispatch } from "react-redux";

import useTutorialState from "../TutorialHooks";
import { Header } from "../Components";

import "./FirstVideoAnalyzedStyle.scss";
import "../TutorialModalstyles.scss";

const FirstVideoAnalyzedStep2 = () => {
  const { activeStep, showStep } = useTutorialState("first-video-analyzed");
  const dispatch = useDispatch();

  if (showStep && activeStep === 2) {
    return (
      <div className="tutorial-modal">
        <div className="FirstVideoAnalyzedStyle">
          <div className="FirstVideoAnalyzedStep2">
            <div className="VideoAnalyzedCompleteIcon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="31"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 15.5C0 11.3891 1.63303 7.44666 4.53984 4.53984C7.44666 1.63303 11.3891 0 15.5 0C19.6109 0 23.5533 1.63303 26.4602 4.53984C29.367 7.44666 31 11.3891 31 15.5C31 19.6109 29.367 23.5533 26.4602 26.4602C23.5533 29.367 19.6109 31 15.5 31C11.3891 31 7.44666 29.367 4.53984 26.4602C1.63303 23.5533 0 19.6109 0 15.5H0ZM14.6155 22.134L23.5393 10.9781L21.9273 9.68853L14.3179 19.1973L8.928 14.7064L7.60533 16.2936L14.6155 22.1361V22.134Z"
                  fill="#1BB172"
                />
              </svg>
            </div>
            <Header
              showProgress={false}
              successMessage="Your video has been analyzed! "
            />

            <div className="description1">
              Click the video card to explore in-depth video insights!
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default FirstVideoAnalyzedStep2;
